import Konva from 'konva'

export default {
  data () {
    return {
      editHistory: [],
      currentIndex: -1
    }
  },
  computed: {
    enableUndo () {
      return this.currentIndex > 0
    },
    enableRedo () {
      return this.currentIndex < (this.editHistory.length - 1)
    }
  },
  methods: {
    resetEditHistory () {
      this.editHistory = []
      this.setInitStack()
    },

    undo () {
      if (this.currentIndex > 0) {
        let vm = this
        this.currentIndex--
        let layerData = this.editHistory[this.currentIndex]
        let newLayer = Konva.Node.create(layerData)
        this.drawLayer.destroy()
        newLayer.setAttr('id', 'shape')
        newLayer.children.each(function (shape) {
          vm.bindListeners(shape)
        })
        this.stage.add(newLayer)
        this.stage.draw()
        this.drawLayer = newLayer
      }
    },

    redo () {
      if (this.currentIndex < this.editHistory.length - 1) {
        let vm = this
        this.currentIndex++
        let layerData = this.editHistory[this.currentIndex]
        let newLayer = Konva.Node.create(layerData)
        this.drawLayer.destroy()
        newLayer.setAttr('id', 'shape')
        newLayer.children.each(function (shape) {
          vm.bindListeners(shape)
        })
        this.stage.add(newLayer)
        this.stage.draw()
        this.drawLayer = newLayer
      }
    },

    pushToHistory () {
      if (this.currentIndex === (this.editHistory.length - 1)) {
        this.editHistory.push(this.drawLayer.toJSON())
      } else {
        this.editHistory.splice(this.currentIndex + 1)
        this.editHistory.push(this.drawLayer.toJSON())
      }
      this.currentIndex = this.editHistory.length - 1
    },

    setInitStack () {
      if (this.drawLayer) { this.editHistory.push(this.drawLayer.toJSON()) }
      this.currentIndex = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/editorHistory.js